import * as paymentOrderHooks from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder/paymentOrder.hooks";
import { TSort } from "@rentiohq/shared-frontend/dist/reduxV2/utils/api.types";
import { uniq } from "lodash";
import { useMemo } from "react";
import { getRentPayerByContract, RENT_ORDER_TYPES } from "./payer.utils";

const RENT_ORDERS_SORT: TSort = [
  { field: "startedAt", method: "DESC" },
  { field: "id", method: "DESC" },
];

// Who pays the rent of each lease on these properties (contractId → payer
// account), from the leases' own rent payment orders. A settlement's payment
// request goes to that person by default: in student housing that is usually
// the parent, not the student. Empty while it loads or when it cannot load.
export const useRentPayers = (
  propertyIds: number[],
): Record<string, number> => {
  const ids = uniq(propertyIds.filter(id => id > 0)).sort((x, y) => x - y);
  const propertyFilter =
    ids.length === 1
      ? { propertyId: { eq: ids[0] } }
      : { or: ids.map(id => ({ propertyId: { eq: id } })) };

  const { items } = paymentOrderHooks.useGetAll({
    shouldRefetch: ids.length > 0,
    query:
      ids.length > 0
        ? {
            filter: {
              and: [propertyFilter, { type: { in: RENT_ORDER_TYPES } }],
            },
            sort: RENT_ORDERS_SORT,
          }
        : undefined,
  });

  return useMemo(() => getRentPayerByContract(items ?? []), [items]);
};
